__turbopack_context__.v({
  "children-container": "nav-bar-module-scss-module__bkexQW__children-container",
  "container": "nav-bar-module-scss-module__bkexQW__container",
  "dark": "nav-bar-module-scss-module__bkexQW__dark",
  "header": "nav-bar-module-scss-module__bkexQW__header",
  "light": "nav-bar-module-scss-module__bkexQW__light",
  "link-text": "nav-bar-module-scss-module__bkexQW__link-text",
  "menu-open": "nav-bar-module-scss-module__bkexQW__menu-open",
  "nav-bar": "nav-bar-module-scss-module__bkexQW__nav-bar",
  "nav-items-container-horizontal": "nav-bar-module-scss-module__bkexQW__nav-items-container-horizontal",
  "nav-items-container-vertical": "nav-bar-module-scss-module__bkexQW__nav-items-container-vertical",
  "nav-link": "nav-bar-module-scss-module__bkexQW__nav-link",
  "nav-menu": "nav-bar-module-scss-module__bkexQW__nav-menu",
  "nav-vertical-wrapper": "nav-bar-module-scss-module__bkexQW__nav-vertical-wrapper",
  "transparent": "nav-bar-module-scss-module__bkexQW__transparent",
});
